import { defineComponent as _defineComponent } from 'vue'
import {
  PaginatedQuery,
  Trade,
  ExportListType,
  getPrimaryCcy,
  AmountType,
  getCurrencyPair,
  formatHedgingInstrument,
  HedgingInstruments,
} from 'ah-api-gateways';
import { defineUseManagedListingProps, useManagedListing, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { PropType, computed, reactive } from 'vue';
import { tradeReportTableFieldsFull } from '../../models/tradeTableFields';
import TradeNotionalValueCell from '../tableCells/TradeNotionalValueCell.vue';
import TradeStatusPill from '../tableCells/TradeStatusPill.vue';
import TradeFxRateCell from '../tableCells/TradeFxRateCell.vue';
import { formatDate, SIMPLE_DATE_FORMAT, FULL_TIME_FORMAT } from 'ah-common-lib/src/helpers/time';
import { useAhTradesState } from '../..';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { capitalize } from 'lodash';
import { formatInTimeZone } from 'date-fns-tz';
import TradesFormattedCurrency from '../../currency/TradesFormattedCurrency.vue';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';

interface TradeEmits extends UseManagedListingEmits<Trade> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeListing',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    required: false,
    default: () => ({ tableFields: tradeReportTableFieldsFull }),
  },
  hidePagination: {
    type: [Boolean, String],
    required: false,
    default: false,
  },
  documentTitle: {
    type: String,
    required: false,
  },
  itemsLabel: {
    type: String,
    required: false,
    default: 'trades',
  },
  tradeStatusLabel: {
    type: String,
    required: false,
    default: 'status',
  },
  ...defineUseManagedListingProps<Trade>(),
},
  setup(__props, { expose, emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;



const state = reactive({
  percentageToBasisConversion: 100,
});

const tradeState = useAhTradesState();



const managedListing = useManagedListing<Trade>({
  loadDataRequest(query: PaginatedQuery) {
    return tradeState.services.trade.listTrades(query);
  },
  downloadDataRequest(type: string, query: { [key: string]: any }) {
    return tradeState.services.trade.downloadTradeList(query, type as ExportListType, props.documentTitle);
  },
  emit,
  props,
  fields: computed(() => props.config.tableFields),
  reqManager: useRequestManager().manager,
});

const onBehalfOfClient = useOnBehalfOf();

function getTradeAmountType(trade: Trade) {
  return getPrimaryCcy(trade).amountType === AmountType.SELL ? 'Sell' : 'Buy';
}

function getTradeCcyPair(trade: Trade) {
  return getCurrencyPair(trade);
}

function isVanilla(trade: Trade) {
  return trade.hedgingProduct === HedgingInstruments.VANILLA_OPTIONS;
}

const isDrawdown = computed(() => {
  return (trade: Trade) => {
    return !!trade.parentTradeId;
  };
});

function getSettlementDate(trade: Trade, dateFormat: string) {
  if (trade.settlementDate) {
    return formatInTimeZone(new Date(trade.settlementDate), 'GMT', dateFormat);
  }

  return '-';
}

const isAdminUser = computed(() => tradeState.store.useAuthStore().isAHUser);

expose({ loadData: managedListing.loadData, downloadData: managedListing.listeners.download });

return { __sfc: true,props, state, tradeState, emit, managedListing, onBehalfOfClient, getTradeAmountType, getTradeCcyPair, isVanilla, isDrawdown, getSettlementDate, isAdminUser, formatHedgingInstrument, TradeNotionalValueCell, TradeStatusPill, TradeFxRateCell, formatDate, SIMPLE_DATE_FORMAT, FULL_TIME_FORMAT, capitalize, formatInTimeZone, TradesFormattedCurrency }
}

})